<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="tab-panel-content-wrapper">

    <h3 class="disclosure-section-title">Global</h3>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Enhanced Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Enables Enhanced Disclosures to be applied directly to MPOP Offer Sets, independent of Dynamic Creative."
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="enhancedDisclosure"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Disclosure Set
        <i class="pi pi-info-circle"
           pTooltip="Select from pre-formatted disclosure templates designed to meet OEM and compliance requirements."
           tooltipPosition="top"></i>
      </label>
      <p-select
        [options]="disclosureSetOptions"
        formControlName="disclosureSet"
        optionLabel="label"
        optionValue="value"
        [pTooltip]="disclosureSetTooltip"
        tooltipPosition="top"></p-select>
    </div>

    <p-divider></p-divider>

    <h3 class="disclosure-section-title">New Disclosure Defaults</h3>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Deal Info in Disclaimer
        <i class="pi pi-info-circle"
           pTooltip="Show Deal Info in Disclaimer"
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="newShowDealInfoInDisclaimer"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Days to First Payment in Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Add days to first payment in finance disclosure section."
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="newShowDaysToFirstPaymentInDisclosure"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Finance Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard finance disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="newFinanceDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Buy Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard purchase disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="newBuyDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        APR Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard APR disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="newAprDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Savings Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Disclosure for savings offers in MPOP"
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="newSavingsDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Lease Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard lease disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="newLeaseDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Alternate Lease Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard zero down or sign & drive disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="newAlternateLeaseDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Disclosure Add-on
        <i class="pi pi-info-circle"
           pTooltip="Text appended to every disclosure for new and used ads"
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="newDisclosureAddon"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show "Photos for illustration purposes only" in Disclosure
        <i class="pi pi-info-circle"
           pTooltip='Includes "Photos for illustration purposes only" in new ad disclosures'
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="newShowPhotosForIllustration"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show All Available Stocks in Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Text appended to every disclaimer for new ads when available (Nissan)"
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="newShowAllAvailableStocks"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Total Available Stocks at this price in Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Text appended to every disclaimer for new ads when available (Nissan)"
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="newShowTotalAvailableStocks"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Only Last 8 Characters of VIN
        <i class="pi pi-info-circle"
           pTooltip="Show Only Last 8 Characters of VIN"
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="newShowLastEightVin"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Pricing Superscripts
        <i class="pi pi-info-circle"
           pTooltip="Show pricing superscripts for all displayed pricing blocks"
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="newShowPricingSuperscripts"></p-toggleswitch>
    </div>

    <p-divider></p-divider>

    <h3 class="disclosure-section-title">Used Disclosure Defaults</h3>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Finance Payment Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard finance disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="usedFinanceDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Days to First Payment in Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Default setting for showing the days to first payment in the finance payment disclosure"
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="usedShowDaysToFirstPaymentInDisclosure"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Buy Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard purchase disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="usedBuyDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        APR Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard APR disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="usedAprDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Savings Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Disclosure for savings offers in MPOP"
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="usedSavingsDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Deals in Disclaimers
        <i class="pi pi-info-circle"
           pTooltip="Show deal info from automatically being included in disclaimers. Globally turn this on/off for all used ads."
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="usedShowDealsInDisclaimers"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Lease Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard lease disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="usedLeaseDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Alternate Lease Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Additional copy that will follow our standard zero down or sign & drive disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="usedAlternateLeaseDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Disclosure Add-on
        <i class="pi pi-info-circle"
           pTooltip="Text appended to every disclosure for used ads"
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea class="input-text-wrapper" formControlName="usedDisclosureAddon"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show "Photos for illustration purposes only" in Disclosure
        <i class="pi pi-info-circle"
           pTooltip='Includes "Photos for illustration purposes only" in used ad disclosures'
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="usedShowPhotosForIllustration"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Only Last 8 Characters of VIN
        <i class="pi pi-info-circle"
           pTooltip="Show Only Last 8 Characters of VIN"
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="usedShowLastEightVin"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Pricing Superscripts
        <i class="pi pi-info-circle"
           pTooltip="Show pricing superscripts for all displayed pricing blocks."
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="usedShowPricingSuperscripts"></p-toggleswitch>
    </div>

  </div>
</form>
